import TableCell, { TableCellProps } from '@mui/material/TableCell'

// The dc-admin tables repeat sx={{ fontWeight: 700 }} on every header cell.
// This wrapper carries that weight in one place while forwarding all TableCell
// props (align, colSpan, children, …) and merging any caller-supplied sx.
export default function TableHeaderCell( { sx, ...props }: TableCellProps ) {
	return (
		<TableCell
			{...props}
			sx={[ { fontWeight: 700 }, ...( Array.isArray( sx ) ? sx : [ sx ] ) ]}
		/>
	)
}
